import * as angular from 'angular';
import * as _ from 'lodash';

import { IApprovalStrategyService } from '../../services';
import { IApprovalStrategy } from '../../models';
import { Store } from '../Store';
import * as APPROVALSTRATEGIES from './approvalStrategies.constants';

import {
    loadApprovalStrategy,
    loadApprovalStrategySuccess,
    loadApprovalStrategies,
    loadApprovalStrategiesSuccess,
    deleteApprovalStrategy,
    deleteApprovalStrategySuccess,
    updateApprovalStrategy,
    updateApprovalStrategySuccess,
    addApprovalStrategySuccess,
    addApprovalStrategy
} from './approvalStrategies.actions';


export interface IApprovalStrategyActionsService {
    getOne(guid: string): (dispatch: any, getState: () => Store) => angular.IPromise<IApprovalStrategy>;
    getAll(): (dispatch: any, getState: () => Store) => angular.IPromise<IApprovalStrategy[]>;
    getAll(force: boolean): (dispatch: any, getState: () => Store) => angular.IPromise<IApprovalStrategy[]>;
    addOne(target: IApprovalStrategy): (dispatch: any, getState: () => Store) => angular.IPromise<IApprovalStrategy[]>;
    // addMany(targets: IApprovalStrategy[]): (dispatch: any, getState: () => Store) => angular.IPromise<IApprovalStrategy[]>;
    updateOne(target: IApprovalStrategy): (dispatch: any, getState: () => Store) => angular.IPromise<IApprovalStrategy[]>;
    // updateMany(targets: IApprovalStrategy[]): (dispatch: any, getState: () => Store) => angular.IPromise<IApprovalStrategy[]>;
    deleteOne(guid: string): (dispatch: any, getState: () => Store) => angular.IPromise<IApprovalStrategy[]>;
    // deleteMany(guids: string[]): (dispatch: any, getState: () => Store) => angular.IPromise<IApprovalStrategy[]>;
}

export class ApprovalStrategyActionsService implements IApprovalStrategyActionsService {

    static serviceId = 'approvalStrategyActionsService';
    static $inject = ['$q', 'approvalStrategyService'];


    constructor(private _$q: angular.IQService,
        private _approvalStrategyService: IApprovalStrategyService) {
    }

    getOne(guid: string) {
        return (dispatch: any, getState: () => Store) => {
            const { approvalStrategies } = getState();
            if (!approvalStrategies.isLoading && !approvalStrategies.isLoaded) {
                dispatch(loadApprovalStrategy());
                return this._approvalStrategyService
                    .getAll(true)
                    .then(data => {
                        const result = data.filter(c => c.guid === guid);
                        dispatch(loadApprovalStrategySuccess(result));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch({ type: APPROVALSTRATEGIES.APPROVAL_STRATEGY_LOAD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.find(_.values<IApprovalStrategy>(approvalStrategies.dictionary), c => c.guid === guid));
            }
        };
    }

    getAll();
    getAll(force: boolean);
    getAll(force?: boolean) {
        return (dispatch: any, getState: () => Store) => {
            const { approvalStrategies } = getState();
            if (force || (!approvalStrategies.isLoading && !approvalStrategies.isLoaded)) {
                dispatch(loadApprovalStrategies());
                return this._approvalStrategyService
                    .getAll(force)
                    .then(data => {
                        dispatch(loadApprovalStrategiesSuccess(data));
                        return data;
                    })
                    .catch((reason) => {
                        dispatch({ type: APPROVALSTRATEGIES.APPROVAL_STRATEGIES_LOAD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<IApprovalStrategy>(approvalStrategies.dictionary));
            }
        };
    }

    addOne(target: IApprovalStrategy) {
        // return this.addMany([target]);
        return (dispatch: any, getState: () => Store) => {
            const { approvalStrategies } = getState();
            if (target) {
                dispatch(addApprovalStrategy([target]));
                return this._approvalStrategyService
                    .addStrategy(target)
                    .then(data => {
                        const result = data;
                        dispatch(addApprovalStrategySuccess([result]));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch({ type: APPROVALSTRATEGIES.APPROVAL_STRATEGY_ADD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<IApprovalStrategy>(approvalStrategies.dictionary));
            }
        };
    }

    // addMany(targets: IApprovalStrategy[]) {
    //     return (dispatch: any, getState: () => Store) => {
    //         const { approvalStrategies } = getState();
    //         if (targets && targets.length > 0) {
    //             dispatch(addApprovalStrategy(targets));
    //             return this._approvalStrategService.addApprovalStrategy(targets)
    //                 .then(data => {
    //                     const result = data;
    //                     dispatch(addApprovalStrategySuccess(result));
    //                     return result;
    //                 })
    //                 .catch((reason) => {
    //                     dispatch({ type: APPROVALSTRATEGY.APPROVAL_STRATEGY_ADD_ERROR, payload: reason });
    //                     return reason;
    //                 });
    //         } else {
    //             return this._$q.when(_.values<IApprovalStrategy>(approvalStrategy.dictionary));
    //         }
    //     };
    // }

    updateOne(target: IApprovalStrategy) {
        return (dispatch: any, getState: () => Store) => {
            const { approvalStrategies } = getState();
            if (target) {
                dispatch(updateApprovalStrategy([target]));
                return this._approvalStrategyService
                    .update(target)
                    .then(data => {
                        const result = data;
                        dispatch(updateApprovalStrategySuccess([result]));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch({ type: APPROVALSTRATEGIES.APPROVAL_STRATEGY_UPDATE_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<IApprovalStrategy>(approvalStrategies.dictionary));
            }
        };
    }

    // updateMany(targets: IApprovalStrategy[]) {
    //     return (dispatch: any, getState: () => Store) => {
    //         const { approvalStrategies } = getState();
    //         if (targets && targets.length > 0) {
    //             dispatch(updateApprovalStrategy(targets));
    //             return this._approvalStrategService.updateApprovalStrategy(targets)
    //                 .then(data => {
    //                     const result = data;
    //                     dispatch(updateApprovalStrategySuccess(result));
    //                     return result;
    //                 })
    //                 .catch((reason) => {
    //                     dispatch({ type: APPROVALSTRATEGY.APPROVAL_STRATEGY_UPDATE_ERROR, payload: reason });
    //                     return reason;
    //                 });
    //         } else {
    //             return this._$q.when(_.values<IApprovalStrategy>(approvalStrategy.dictionary));
    //         }
    //     };
    // }

    deleteOne(guid: string) {
        return (dispatch: any, getState: () => Store) => {
            const { approvalStrategies } = getState();
            if (guid) {
                dispatch(deleteApprovalStrategy([guid]));
                return this._approvalStrategyService
                    .deleteStrategy(guid)
                    .then(data => {
                        const result = data;
                        dispatch(deleteApprovalStrategySuccess([approvalStrategies.dictionary[guid]]));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch({ type: APPROVALSTRATEGIES.APPROVAL_STRATEGY_DELETE_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<IApprovalStrategy>(approvalStrategies.dictionary));
            }
        };
    }

    // deleteMany(guids: string[]) {
    //     return (dispatch: any, getState: () => Store) => {
    //         const { approvalStrategies } = getState();
    //         if (guids && guids.length > 0) {
    //             dispatch(deleteApprovalStrategy(guids));
    //             return this._approvalStrategService.deleteApprovalStrategy(guids)
    //                 .then(data => {
    //                     const result = data;
    //                     dispatch(deleteApprovalStrategySuccess(result));
    //                     return result;
    //                 })
    //                 .catch((reason) => {
    //                     dispatch({ type: APPROVALSTRATEGY.APPROVAL_STRATEGY_DELETE_ERROR, payload: reason });
    //                     return reason;
    //                 });
    //         } else {
    //             return this._$q.when(_.values<IApprovalStrategy>(approvalStrategy.dictionary));
    //         }
    //     };
    // }
}